var map = {
	"./qh-cn.mp3": "b06e",
	"./qh-en.mp3": "8879",
	"./qh-hk.mp3": "ee7d",
	"./zq+qh-cn.mp3": "ce74",
	"./zq+qh-en.mp3": "5848",
	"./zq+qh-hk.mp3": "edc6",
	"./zq-cn.mp3": "49d4",
	"./zq-en.mp3": "67da",
	"./zq-hk.mp3": "ae8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dacb";